module.exports = __webpack_public_path__ + "img/passport_en-us.e903d96b.png";